export const DEFAULT_CATEGORY = 'DEFAULT';
export const DEFAULT_CATEGORY_LABEL = 'DXM';
